module.exports = __webpack_public_path__ + "static/media/logoBloomberg.33627575.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/logoBloomberg.svg
// module id = 189
// module chunks = 0